module.exports = "<!--<p>\n  user works!\n</p>-->\n\n<router-outlet></router-outlet>\n"